import { useCallback } from "react";
import { Form } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Toggleable } from "../../../hook/useToggle";
import BusyButton from "../../common/busy-button";
import { AddIcon, CloseIcon } from "../../common/icons";
import PositionInfoPanel from "./position-info-panel";
import { usePositionTitleState } from "./position-manager-context";
import './style.scss';
import usePositionTitleApi from "./usePositionTitleApi";

export interface NewPositionModalProps extends Toggleable {
  showDuplicateConfirmation(): void
}

const NewPositionModal = (props: NewPositionModalProps) => {

  const { isOpen, toggle, showDuplicateConfirmation } = props;

  const { form } = usePositionTitleState();

  const { createPositionTitle, busy } = usePositionTitleApi();

  const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    createPositionTitle(form)
      .then(ok => ok && toggle())
      .catch((e: Error) => { showDuplicateConfirmation(); });
  }, [form]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg" scrollable autoFocus={false}>
      <ModalHeader toggle={toggle} tag={'h2'}>Create New Position/Role Title</ModalHeader>
      <ModalBody className="p-4">
        <Form id="new_position_form" className="oms-container" onSubmit={handleSubmit}>
          <fieldset className="oms-frame p-3">
            <legend>Position/Role Title Information (Required Fields)</legend>
            <PositionInfoPanel autoFocus={true} />
          </fieldset>
        </Form>
      </ModalBody>
      <ModalFooter>
        <BusyButton type="submit" form="new_position_form" aria-label="Create" color="primary"
          value="Create" busy={busy}>
          <AddIcon />
        </BusyButton>
        <Button color="secondary" onClick={toggle}><CloseIcon /> Cancel</Button>
      </ModalFooter>

    </Modal>
  );
};

export default NewPositionModal;
